module.exports = __webpack_public_path__ + "img/detail-close-icon.8f0d99da.svg";